import { Box, Typography } from "@mui/material";
import SleepIcon from "../icons/SleepIcon";

const NothingHereYet = ({ message }: { message?: string }) => (
    <Box
        sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
        }}
    >
        <SleepIcon fontSize="large" sx={{ color: "text.secondary" }} />
        {message && (
            <Typography variant="body1" color="textSecondary">
                {message}
            </Typography>
        )}
    </Box>
);

export default NothingHereYet;
